import FieldsCollection from "../../../fields3/collection/base/fields-collection";
import FieldMoment from "../../../fields3/generic/datetime/moment/moment";
import {EntityType} from "../../../gd/const/item";
import {FieldType} from "../../../fields3/field-type";
import FieldTask from "../../../fields3/generic/task/task";
import FieldReminder from "../../../fields3/generic/reminder/reminder";
import FieldString from "../../../fields3/generic/string/string";
import FieldMeeting from "../../../fields3/generic/meeting/meeting";
import FieldEvent from "../../../fields3/generic/event/event";
import FieldDate from "../../../fields3/generic/datetime/date/date";
import FieldCurrency from "../../../fields3/generic/finance/currency/currency";


const baseConfig = [

    {
        fieldId : 'id',
        type    : FieldType.STRING,
        label   : 'ID'
    },

    {
        fieldId     : 'startMoment',
        type        : FieldType.DATE,
        label       : 'Start Date'
    },
    {
        fieldId     : 'endMoment',
        type        : FieldType.DATE,
        label       : 'End Date'
    },

    {
        fieldId     : 'laborRate',
        label       : 'Labor Rate',
        type        : FieldType.CURRENCY,
        minValue         : 0
    },
    {
        fieldId     : 'serviceRate',
        label       : 'Service Rate',
        type        : FieldType.CURRENCY,
        minValue         : 0
    }
]

export default class TimeCostHistoryFields extends FieldsCollection {


    // Quick access

    // get id()                { return this.get('id') as FieldString }
    get startMoment()       { return this.get('startMoment') as FieldDate }
    get endMoment()       { return this.get('endMoment') as FieldDate }
    get laborRate()       { return this.get('laborRate') as FieldCurrency }
    get serviceRate()       { return this.get('serviceRate') as FieldCurrency }



    constructor() {
        const fieldsConfig = baseConfig;
        super(fieldsConfig, EntityType.HOURLY_COST_HISTORY);
    }





}